var React = require('react');

function Zug (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#FFF","d":"M0 0h470v470H0z","key":0}),React.createElement("path",{"fill":"#0073E5","d":"M0 156.667h470v156.667H0z","key":1})]));
}

Zug.defaultProps = {"viewBox":"0 0 470 470"};

module.exports = Zug;

Zug.default = Zug;
